export default basicParty = `
export default {
    "affiliation": "good",
    "inventory": {"gold": 0},
    "party": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 50,
                "moverange": 2,
                "skillKeys": [
                    "inflict-damage",
                    "rally",
                    "recruit",
                ],

                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",

                "scripts": {
                    "death": "Damn."
                },

                "portraits": {
                    "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral2.png"),
                    "angry": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-angry.png"),
                    "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-happy.png"),
                },
            },
            "hero": {
                "key": "hero",
                "jobKey": "axe",
                "aliases": ["Himmel", "paladin", "Masked Man"],
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 50,
                "skillKeys": [
                    "inflict-damage",
                    "smite",
                    "recruit",
                ],

                "name": "HERO",
                "faceKey": "human",
                "bodyKey": "good",

                "scripts": {
                    "death": "Damn."
                },
            },
            "friend": {
                "key": "friend",
                "jobKey": "bow",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 40,
                "skillKeys": [
                    "inflict-damage",
                    "pull",
                    "recruit",
                ],

                "name": "FRIEND",
                "faceKey": "human",
                "bodyKey": "good",

                "scripts": {
                    "death": "Damn."
                },
            },
            "aide": {
                "key": "aide",
                "jobKey": "dagger",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 40,
                "skillKeys": [
                    "inflict-damage",
                    "swap",
                    "recruit",
                ],

                "name": "AIDE",
                "faceKey": "human",
                "bodyKey": "good",

                "scripts": {
                    "death": "Damn."
                },
            },
        }
    },
}
`
